import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { useText, useConfig } from 'common/hooks';

import LaTim01 from './Welcome';
import LaTim02 from './CampaignList';
import GMod18 from './ExplanationModal';

import { Wrapper, LoaderWrapper, Loader, Version } from './elements';

const deps = {
  explanationModalShowing: state.account.timeline.explanationModalShowing,
  isLoaded: state.account.timeline.loaded,
};

export function Timeline({
  explanationModalShowing,
  isLoaded,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  if (isLoaded) {
    return (
      <Wrapper>
        {explanationModalShowing && (
          <GMod18
            heading={t(`account.timeline.${explanationModalShowing}.heading`)}
            subheading={t(
              `account.timeline.${explanationModalShowing}.subheading`
            )}
            text={t(`account.timeline.${explanationModalShowing}.text`)}
            image={`${staticUrl}/images/mobile-${
              explanationModalShowing.split('.')[0]
            }.png`}
          />
        )}
        <LaTim01 />
        <LaTim02 />
        <Version>
          {`Build: ${process.env.SOURCE_VERSION || 'development'}`}
        </Version>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <LoaderWrapper>
        <Loader color={'#fff'} />
      </LoaderWrapper>
    </Wrapper>
  );
}

export default connect(deps, Timeline);
